import { apiHelper } from '@/utils'
import { API } from '@/constants'
import { sharedHelper } from '@/utils';

export const tyreBrandService = {
    getAlltyreBrands,
    gettyreBrand,
    updatetyreBrand,
    updatetyreBrandStatus,
    createtyreBrand 
};

const MODULE = {
    BRAND: 'tyre-brands',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAlltyreBrands(filter) {
    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            is_active: filter.isActive,
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })
    return apiHelper(API_URL).get(`/${MODULE.BRAND}`, requestOptions)
}

export function gettyreBrand(id) {

    return apiHelper(API_URL).get(`/${MODULE.BRAND}/${id}`)
}

export function updatetyreBrand(data) {
    const formData = new FormData();
    sharedHelper.appendIfNotNull(formData,'name', data.name);
    formData.append('_method', "put");
    
    if (data.image instanceof File) {
        formData.append('image', data.image);
      }

    return apiHelper(API_URL).post(`/${MODULE.BRAND}/${data.id}`, formData)     
}

export function createtyreBrand(data) {
    const formData = new FormData();
    sharedHelper.appendIfNotNull(formData,'name', data.name);
    
    if (data.image instanceof File) {
        formData.append('image', data.image);
      }
      
    return apiHelper(API_URL).post(`/${MODULE.BRAND}`, formData)
}

export function updatetyreBrandStatus(data) {
    
    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.BRAND}/${data.id}`, requestOptions)
}

